<template>
    <div class="content-wrap">
      <div class="register-wrap">
        <div class="row">
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="이벤트 이름(행사명)" :required="true">
                <template #end="{id}">
                  <ElInput :id="id" ref="eventNmRef" v-model="state.eventParams.event_nm"  @update:modelValue="r=>getNameMask('eventNmRef',r)" :maxlength="50"/>
                </template>
              </ElLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              
              <ElLabel name="일시" :required="true">
                <template #end="{id}">
                  <div class="d-flex justify-content-between">
                    <DatePicker ref="eventDtRef" :select-date="state.eventParams.event_dt"  @return="r => state.eventParams.event_dt = r" />
                  </div>
                </template>
              </ElLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="장소" :required="true">
                <template #end="{id}">
                  <ElInput :id="id" ref="eventPlace" v-model="state.eventParams.event_place" @update:modelValue="r=>getNameMask('eventPlace',r)" :maxlength="100"/>
                </template>
              </ElLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="목적">
                <template #end="{id}">
                  <ElInput :id="id" v-model="state.eventParams.prpss" :maxlength="50"/>
                </template>
              </ElLabel>
  
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="주관사" :required="true">
                <template #end="{id}">
                  <ElInput :id="id" ref="sponsor" v-model="state.eventParams.sponsor" @update:modelValue="r=>getNameMask('sponsor',r)" :maxlength="20"/>
                </template>
              </ElLabel>
  
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="발표자">
                <template #end="{id}">
                  <ElInput :id="id" v-model="state.eventParams.prsnt" :maxlength="10"/>
                </template>
              </ElLabel>
  
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="행사장 규모">
                <template #end="{id}">
                  <ElInput :id="id" v-model="state.eventParams.event_scale" :maxlength="512"/>
                </template>
              </ElLabel>
  
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="행사 증정품">
                <template #end="{id}">
                  <ElInput :id="id" v-model="state.eventParams.gift" :maxlength="20"/>
                </template>
              </ElLabel>
  
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="mb-3">
              <ElLabel name="행사내용">
                <template #end="{id}">
                  <ElInput :id="id" v-model="state.eventParams.event_dtls" :maxlength="512"/>
                </template>
              </ElLabel>
            </div>
          </div>
        </div>
        <div class="row band">
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="클레임 비용">
                <template #end="{id}">
                  <ElInput :id="id" ref="claimCostRef" :maxlength="17" @update:modelValue="r=>numberMask(r)"/>
                </template>
              </ElLabel>
  
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="마케팅 펀딩사">
                <template #end="{id}">
                  <ElInput :id="id" v-model="state.eventParams.mk_fund"/>
                </template>
              </ElLabel>
  
            </div>
          </div>
          <div class="col-md-6">
            <div class="mb-3">
              <ElLabel name="클레임 처리방법">
                <template #end="{id}">
                  <ElInput :id="id" v-model="state.eventParams.claim_mthd"/>
                </template>
              </ElLabel>
            </div>
          </div>
          <!--todo : captionList 공통컴포넌트 적용-->
          
            <Caption
              ref="captionRef"
              :tbId="'event'"
              :cap_seq="state.eventParams.ev_seq"
            />
          
        </div>
      </div><!-- //register-wrap -->
  
      <div class="text-end py-3">
        <ElButton type="primary" @buttonClick="openModal('upload')">일괄등록</ElButton>
        <ElButton type="primary" @buttonClick="goBack()">이전</ElButton>
        <!-- <ElButton type="primary" @buttonClick="ItemValidation('Y')">임시저장</ElButton>
        <ElButton type="primary" @buttonClick="router.push('/mp/MMP_AM_001')">임시저장함</ElButton> -->
        <ElButton type="primary" @buttonClick="ItemValidation('N')">수정완료</ElButton>
      </div>
      <div class="accordion" id="accordionPanelsStayOpenExample">
        <div class="accordion-item">
          <h2 class="accordion-header">
            <ElButton type="accordionHeader" target="panelsStayOpen-collapseOne">
              설문내용(첨부파일)
            </ElButton>
          </h2>
          <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse">
            <div class="accordion-body accordion-body-register">
              <!-- <table>
                <tr></tr>
              </table> -->
              <FileUpload ref="fileUploadRef" @return="res => getFileList(res)" @deleteData="res => getDeleteFile(res)" />
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <ExcelUploadModal ref="excelUploadModalRef" :fileNm = "state.excelFileName" :colDefs="state.excelModalColDefs" @return="saveAll" />
  
  
  </template>
  
  <script setup>
  import { reactive, ref, computed, onBeforeMount } from 'vue'
  import DatePicker from '@/components/common/DatePicker.vue';
  import Caption from '@/components/common/CaptionList.vue';
  import { useRouter } from "vue-router";
  import FileUpload from '@/components/common/FileUpload.vue';
  import common from '@/js/common';
  import routerCmn from '@/js/vueRouterCmn';
  import ExcelUploadModal from "@/components/common/modal/ExcelUploadModal.vue";
  import { useCodeStore } from '@/store/code'
  const codeStore = useCodeStore()
  
  import { useLoading } from '@/composable/Loading.js'
  const { setIsLoading } = useLoading()
  import { eventSelect, eventEdit } from '@/api/event';
  import { fileList } from '@/api/file';
  const router = useRouter();
  const fileUploadRef = ref()
  const eventNmRef = ref()
  const eventPlace = ref()
  const sponsor = ref()
  const excelUploadModalRef = ref();
  const captionRef = ref();
  const eventDtRef = ref()
  const claimCostRef = ref()
  // var dt=new Date();
  // var dtStr=dt.getFullYear()+'-'+(dt.getMonth()+1)+'-'+dt.getDate();
  
  onBeforeMount(async () => {
    // state.eventParams.event_dt = dtStr;
    let ev_seq = history.state.ev_seq;
  
    if (ev_seq) {
      let param = {
        ev_seq: ev_seq
      }
      eventDetailPage(param)
      
    }else{
      alert('잘못된 접근방식입니다.')
      router.back()
    }
  })
  
  const eventDetailPage = (async(param) =>{
    try {
        setIsLoading(true)
        const res = await eventSelect(param)
        let detailSm = res.rtn
        if(Object.keys(detailSm).length <= 0){
          alert("조회 데이터가 없습니다. 확인해주세요 ")
          routerCmn.routerPush('/sm/MSM_SA_008')
          return
        }
        // 이벤트 이름 : event_nm
        // 일시 : event_dt
        // 장소 : event_place
        // 목적 : prpss
        // 주관사 : sponsor
        // 발표자 : prsnt
        // 행사장규모 : event_scale
        // 행사증정품 : gift
        // 행사내용 : event_dtls
        // 클레임비용 : claim_cost
        // 마케팅펀딩사 : mk_fund
        // 클레임처리방법 : claim_mthd
  
        state.eventParams.ev_seq = detailSm.ev_seq
        state.eventParams.event_nm = detailSm.event_nm
        state.eventParams.event_dt = detailSm.fmt_event_dt
        state.eventParams.event_place = detailSm.event_place
        state.eventParams.prpss = detailSm.prpss
        state.eventParams.sponsor = detailSm.sponsor
        state.eventParams.prsnt = detailSm.prsnt
        state.eventParams.event_scale = detailSm.event_scale
        state.eventParams.gift = detailSm.gift
        state.eventParams.event_dtls = detailSm.event_dtls
        numberMask(detailSm.claim_cost)
        state.eventParams.mk_fund = detailSm.mk_fund
        state.eventParams.claim_mthd = detailSm.claim_mthd
  
        //첨부파일이 존재할경우 파일리스트 조회api 호출
        if (detailSm.file_seq_grp != '' && detailSm.file_seq_grp != null && detailSm.file_seq_grp != undefined) {
          let apiParam = {
            file_seq_grp: detailSm.file_seq_grp
          }
          try {
            const resFileList = await fileList(apiParam)
            fileUploadRef.value.state.fileParams.fileListVo = resFileList.rtn
          } catch (err) {
            console.log('파일리스트 조회 api 에러', err)
            alert('파일리스트 조회에 실패했습니다.')
            throw err
          }
        }
      } catch (err) {
        console.log('이벤트 상세조회 api 에러', err)
        alert('이벤트 상세 조회에 실패했습니다.')
        routerCmn.routerPush('/sm/MSM_SA_007')
      } finally {
        setIsLoading(false)
      }
  })

  const state = reactive({
    eventParams: {
      ev_seq: '',
      event_nm: '',
      event_dt: '',
      event_place: '',
      prpss: '',
      sponsor: '',
      prsnt: '',
      event_scale: '',
      gift: '',
      event_dtls: '',
      claim_cost: 0,
      claim_cost_str : '0',
      mk_fund: '',
      claim_mthd: 0,
      tmp_yn: 'N',
      del_yn: 'N',            // 삭제여부
      cap_seq : 0,
      tb_id : 'event',
      attachFileVO: {
        file_div_id: '10',
        file_seq: '',         // 추가 된 파일 seq 전송
        del_file_seq: ''      // 삭제해야 할 파일 seq 전송
      }
    },
    //파일 첨부 데이터
    fileList: [],
    delFileList: [],
    excelModalColDefs: [
      { header: "이벤트 이름(행사명)", field: "event_nm", req: true, style: { minWidth: '100px' } },
      { header: "일시", field: "event_dt", req: true, style: { minWidth: '100px' },type:'date' },
      { header: "장소", field: "event_place", req: true, style: { minWidth: '100px' } },
      { header: "목적", field: "prpss", style: { minWidth: '100px' } },
      { header: "주관사", field: "sponsor", req: true, style: { minWidth: '100px' } },
      { header: "발표자", field: "prsnt", style: { minWidth: '100px' } },
      { header: "행사장 규모", field: "event_scale", style: { minWidth: '100px' } },
      { header: "행사 증정품", field: "gift", style: { minWidth: '100px' } },
      { header: "행사내용", field: "event_dtls", style: { minWidth: '100px' } },
      { header: "클레임 비용", field: "claim_cost", type: 'number', style: { minWidth: '100px' } },
      { header: "마케팅 펀딩사", field: "mk_fund", style: { minWidth: '100px' } },
      { header: "클레임 처리방법", field: "claim_mthd", style: { minWidth: '100px' } },
    ],
    excelFileName: "이벤트 템플릿"
  })
  
  const goBack = () => {
  
    if (state.eventParams.event_nm || state.eventParams.event_dt || state.eventParams.event_place || state.eventParams.sponsor ||
      state.eventParams.prpss || state.eventParams.prsnt || state.eventParams.event_dtls || state.eventParams.event_scale ||
      state.eventParams.gift || state.eventParams.gift || state.eventParams.mk_fund || state.eventParams.claim_cost || state.eventParams.claim_mthd) {
      if (confirm("저장되지 않은 데이터가 있습니다.\n뒤로 가시겠습니까?") == true) {
        router.go(-1);
      }
    }
  }
  
  // 숫자형식 포맷 (10,000, 숫자만 들어갈 수 있도록)  
  const numberMask = (data) => {
    data = data.replaceAll(/[^0-9]/g, '')
    state.eventParams.claim_cost = data
    data = common.checkNumberComma(data)
    claimCostRef.value.input.value = data
  }
  
  
  //업로드 파일 저장 후 실행되는 함수
  const getFileList = (res) => {
  
    if (res && res?.length > 0) {
      res.map((file) => {
        state.fileList.push(file.file_seq)
      })
  
      RegClick()
    } else {
      alert('파일 업로드에 실패했습니다.')
    }
  
  }
    //특수문자
    const getNameMask = (type,data = '') => {
      let uptData = common.checkSpecChar(data)
      switch(type){
        case 'eventNmRef' : 
        state.eventParams.event_nm = uptData
          break
        case 'eventPlace' : 
        state.eventParams.event_place = uptData
          break
        case 'sponsor' : 
        state.eventParams.sponsor = uptData
          break
      }
  
      return uptData
  }

  const ItemValidation = async(status) => {
  
    let msg = codeStore.getCodeMsg('77777'); // 해당 항목은 필수 입력값입니다.
    
    if(status == 'N'){
      if (!state.eventParams.event_nm) {
      alert(msg)
      eventNmRef.value.input.focus()
      return false
      }
      if (!state.eventParams.event_dt) { //일시
        alert('일시는 필수값 입니다.')
        return false
      }
      if (!state.eventParams.event_place) { //장소
        alert(msg)
        eventPlace.value.input.focus()
        return false
      }
    
      if (!state.eventParams.sponsor) { //주관사
        alert(msg)
        sponsor.value.input.focus()
        return false
      }
    let res = await captionRef.value.checkValidation()
    if(!res){
      return
    }
  }
    let confirmMsg = '';
    if (status == 'Y') {
      confirmMsg = '정말 임시저장 하시겠습니까?';
    }
    else {
      confirmMsg = '정말 등록하시겠습니까?';
    }
    
    if(confirm(confirmMsg)){
    //저장 상태값
    state.eventParams.tmp_yn = status
    RegClick(status);
  }
  }
  
  const RegClick = async () => {
  
    //파일 첨부 데이터가 있는지 확인
    let tmpFiles = fileUploadRef.value.state.tmpFileList
    if (tmpFiles.length > 0) {
      //임시파일이 있으면 실제 경로 저장
      fileUploadRef.value.uploadFile()
      return
    } 

    if (state.fileList.length > 0) {
      state.eventParams.attachFileVO.file_seq = state.fileList.toString()
    }
  
    if (state.delFileList.length > 0) {
      state.eventParams.attachFileVO.del_file_seq = state.delFileList.toString()
    }
  
    let params = {
      ev_seq: state.eventParams.ev_seq,
      event_nm: state.eventParams.event_nm,
      event_dt: state.eventParams.event_dt ? state.eventParams.event_dt.replaceAll('-','') : null,
      event_place: state.eventParams.event_place,
      sponsor: state.eventParams.sponsor,
      prpss: state.eventParams.prpss,
      prsnt: state.eventParams.prsnt,
      event_dtls: state.eventParams.event_dtls,
      event_scale: state.eventParams.event_scale,
      gift: state.eventParams.gift,
      mk_fund: state.eventParams.mk_fund,
      claim_cost: state.eventParams.claim_cost || 0,
      claim_mthd: state.eventParams.claim_mthd,
      tmp_yn: state.eventParams.tmp_yn,
      del_yn: state.eventParams.del_yn,
      attachFileVO: {
        file_div_id: state.eventParams.attachFileVO.file_div_id,
        file_seq: state.eventParams.attachFileVO.file_seq,
        del_file_seq: state.eventParams.attachFileVO.del_file_seq
      }
  
    }
  
    // 등록, 수정 처리
    try {
      setIsLoading(true)
      const res = await eventEdit(params)
      if(res.rtn && res.rtn.ev_seq){
        const capRes = await captionRef.value.saveCapCtnt(res.rtn.ev_seq)
        if(capRes.code ==='0000'){
          if(state.eventParams.tmp_yn === 'Y'){
            router.go(0)
            return
          }else{
            alert('등록 성공 조회 페이지로 이동합니다.')
            router.push({ name: 'MSM_SA_008' })
            return
          }
        }
      }
    
      throw new Error()
    } catch (err) {
      alert("전송 중 에러가 발생하였습니다.");
    } finally {
      setIsLoading(false)
    }
  }
  
  const getDeleteFile = (res) => {
    state.delFileList.push(res.file_seq)
  }
  

  const openModal = (modal) => {
    switch (modal) {
      case 'upload':
        excelUploadModalRef.value.openModal();
    }
  };
  </script>